import { render, staticRenderFns } from "./PolicyTasks.vue?vue&type=template&id=fd88410a"
import script from "./PolicyTasks.vue?vue&type=script&lang=js"
export * from "./PolicyTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports